import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homeHeader" }
const _hoisted_2 = { class: "homeHeader-nav" }
const _hoisted_3 = { class: "homeHeader--actions" }

import { UserGetters, UserActions } from '@/store/modules/user';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import QrcodeVue from 'qrcode.vue'


import { defineComponent } from 'vue';
import BreadCrumbNav from '@/components/nav/BreadCrumbNav.vue';

const __default__ = defineComponent({
    name: 'HomeHeader',
    components: {
        BreadCrumbNav,
    }
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const userinfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});

// const secret = ref<string>("")
const dialogVisible = ref<boolean>(false)
const genQrCode = () => {
    dialogVisible.value = true
}
const handleLogout = () => {
    store.dispatch(`user/${UserActions.logout}`);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BreadCrumbNav)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          onClick: genQrCode
        }, {
          default: _withCtx(() => [
            _createTextVNode("二维码绑定")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          onClick: handleLogout
        }, {
          default: _withCtx(() => [
            _createTextVNode("登出")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: "30%"
    }, {
      default: _withCtx(() => [
        _createVNode(QrcodeVue, {
          value: 'otpauth://totp/' + _unref(userinfo).username + '?secret=' + _unref(userinfo).otpCode,
          size: 200,
          level: "H"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})